import React from 'react'
import {NavLinkR, NavLinkActive} from './NavLink'

let Links = [
    {
        title : 'Home',
        link : '/'
    },
    {
        title : 'About',
        link : ''
    },
    {
        title : 'Gallery',
        link : '/gallery'
    },

]

const Navbar= ({active}) => {



    return (
        <div className='flex flex-row justify-between w-full items-center 
         h-[65px] mb-[25px] md:mb-0 md:h-[144px] 
         '>
           
          <div>
              <h1 className='text-[20px] font-[#000] font-bold cursor-pointer'> IZEELOGO. </h1>
          </div>
         
          <ul className='hidden md:flex justify-between items-center md:w-[286px] z-50 '>
          {Links.map((nav, index)=> {
           return active === nav.title ? 
            (<NavLinkActive title={nav.title} link={nav.link} key={index} />) 
            :
            (<NavLinkR title={nav.title} link={nav.link} key={index} />)
          }
            
          )}
          </ul>

          {/* Mobile Nav */}

          <ul className='flex md:hidden fixed bottom-0 left-0 right-0
           bg-[#fff] w-full h-[66px] justify-evenly items-center  z-50 '>
          {Links.map((nav, index)=> {
           return active === nav.title ? 
            (<NavLinkActive title={nav.title} link={nav.link} key={index} mobile />) 
            :
            (<NavLinkR title={nav.title} link={nav.link} key={index} mobile />)
          }
            
          )}
          </ul>
        
        </div>
    )
}


export default Navbar